var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavourite1 = function SvgFavourite1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.556 18.034a1.15 1.15 0 0 0-1.112 0l-4.635 2.562.899-5.512a1.15 1.15 0 0 0-.312-.988l-3.84-3.936 5.256-.803a1.15 1.15 0 0 0 .867-.648l-.678-.319.678.319L12 3.765l2.32 4.944c.163.347.489.59.868.648l5.256.803-3.84 3.936a1.15 1.15 0 0 0-.312.988l.9 5.512-4.636-2.562Zm8.364-8.361Z",
    stroke: "#666",
    strokeWidth: 1.5
  })));
};
export default SvgFavourite1;